<template lang="pug">
  .container
    .columns.is-vcentered
      .column.is-3
        label.label Usuarios
        TypeaheadUsuario(:options="usuarios" :optionSelect="usuarioSel" v-model="usuarioSel" :isDisabled="isDisabled")
      .column.is-2(v-show="verSelect")
        .field
          label.label Efectivale Entrega
            .control.has-icons-left
              .select.is-dark.is-rounded
                select(v-model="tarjetaEntrega" :disabled="isDisabled")
                  option(v-for="tarj in tarjetasPropias" :key="tarj.id" :value="tarj") {{ tarj.serie }}
              .icon.is-small.is-left
                i.far.fa-credit-card
      .column.is-2(v-show="verSelect")
        .field
          label.label Efectivale Recibe
            .control.has-icons-left
              .select.is-dark.is-rounded
                select(v-model="tarjetaRecibe" :disabled="isDisabled")
                  option(v-for="tarj in tarjetas" :key="tarj.id" :value="tarj") {{ tarj.serie }}
              .icon.is-small.is-left
                i.far.fa-credit-card
      .column.is-2(v-show="verSelect")
        label.label Fecha:
        .field
          .control
            flat-pickr(
              v-model='fecha'
              :config="config"
              class="input"
            )
      .column.is-2(v-show="verSelect")
        .field
          label.label Cantidad
            .control.has-icons-left.has-icons-right
              input.input.is-dark(
                type='text', 
                placeholder='Cantidad',
                v-model="cantidad",
                :disabled="isDisabled"
              )
    .columns(v-show="Object.keys(datosFaltantes).length > 0")
      .column.is-12
        .notification
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
    .columns(v-show="verSelect")
      a.button.is-black.is-rounded(@click="checkForm")
        | Guardar Asignación
</template>

<script>
  import TypeaheadUsuario from "@/components/usuarios_Componentes/componentes/TypeaheadUsuario.vue"
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import { mapState } from 'vuex'

  import moment from 'moment'
  export default {
    name: 'FormTraspaso',
    components: { TypeaheadUsuario, flatPickr },
    props: {
      usuarios: {
        type: Array,
        default: []
      },
      
      tarjetasPropias: {
        type: Array,
        default: []
      },

      tarjetas: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        usuarioSel: {},
        tarjetaEntrega: {},
        tarjetaRecibe: {},
        mes: null, 
        anio: null, 
        isDisabled: false,
        verSelect: false,
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        fecha: moment().format('YYYY-MM-DD'),
        isExtra: false,
        cantidad: 0,
        datosFaltantes: []
      }
    },
    watch: {
      usuarioSel() {
        this.$emit('usuarioSel', this.usuarioSel)
      },
      tarjetas() {
        if (this.tarjetasPropias.length == 0 && this.tarjetas.length == 0) {
          this.verSelect = false
        } else {
          this.verSelect = true
        }
      },
      tarjetasPropias() {
        if (this.tarjetas.length == 0 && this.tarjetasPropias.length == 0) {
          this.verSelect = false
        } else {
          this.verSelect = true
        }
      }
    },
    methods: {
      checkForm() {
        this.datosFaltantes = []
        if (Object.keys(this.usuarioSel).length > 0 && Object.keys(this.tarjetaEntrega).length > 0 && Object.keys(this.tarjetaRecibe).length > 0 && this.fecha !== '' && this.cantidad > 0) {
          this.sendForm()
        } else {
          if (Object.keys(this.usuarioSel).length == 0) {
            this.datosFaltantes.push('El usuario es requerido.')
          }
          if (Object.keys(this.tarjetaEntrega).length == 0) {
            this.datosFaltantes.push('La tarjeta es requerida.')
          }

          if (this.fecha === '') {
            this.datosFaltantes.push('La Fecha de asignación es es requerida.')
          }

          if (this.cantidad == 0) {
            this.datosFaltantes.push('La Cantidad debe ser mayor a 0.')
          }
        }
      },
      sendForm () {
        let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
        let extraInt = 0
        let periodo = moment(this.fecha).format('YYYY-MM')

        let myObj = {
          fechaReg: fechaReg,
          fechaMov: this.fecha,
          periodo: periodo,
          idE: this.userLogin.id,
          ent: this.userLogin.nombre,
          idRec: this.usuarioSel.id,
          ubicacion: this.usuarioSel.ubicacion,
          area: parseInt(this.usuarioSel.departamento),
          rec: this.usuarioSel.nombre,
          idTE: this.tarjetaEntrega.id,
          noTE: this.tarjetaEntrega.serie,
          idTR: this.tarjetaRecibe.id,
          noTR: this.tarjetaRecibe.serie,
          cant: Number(this.cantidad),
        }

        this.$emit('saveForm', myObj)

      }
      
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/FormTraspaso.vue